module.exports = __webpack_public_path__ + "img/founder.68a74908.jpg";